import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-loanSecurityDept/loanSecurityDept/page',
        method: 'post',
        data: {
            ...params,
            current,
            size
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-loanSecurityDept/loanSecurityDept/remove',
        method: 'post',
        data: {
            id,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanSecurityDept/loanSecurityDept/saveOrUpdate',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanSecurityDept/loanSecurityDept/saveOrUpdate',
        method: 'post',
        data: row
    })
}

export const updateBond = (row) => {
    return request({
        url: '/api/blade-loanSecurityDept/loanSecurityDept/updateSecurity',
        method: 'post',
        data: row
    })
}


export const exportData = (data) => {
    return request({
        url: `/api/blade-loanSecurityDept/loanSecurityDept/export-loanSecurityDept`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}

export const startSecurityUpdate = (data) => {
  return request({
      url: `/api/blade-loanSecurityDept/loanSecurityDept/startSecurityUpdate`,
      method: "post",
      data: data,
  });
}
